import React from "react";
import { ApolloProvider, Query } from "react-apollo";
import client from "lib/ApolloClient";
import gql from "graphql-tag";
import { autobind } from "react-decoration";
import qs from "query-string";
import { navigate } from "gatsby";
import ReactLoading from "react-loading";

const getResourceJo2DBMapping = gql`
  query getResourceJo2DBMapping($searchForm: SearchForm) {
    getResourceJo2DBMapping(Input: $searchForm) {
      jo2DBItemList {
        resourceID
        ebName
        enEbName
        jo2DBCount
      }
      maxMoreNum
    }
  }
`;

class ResourceJo2DBMapping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: props.readerStore.auth,
      showMore: false,
    };
  }

  @autobind
  setDBID(resourceID, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.dbID = resourceID;
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  changeShowMore(type, e) {
    e.preventDefault();
    this.setState({ showMore: type });
  }

  render() {
    let { searchForm, i18n, t } = this.props;
    let { language } = i18n;
    let { showMore } = this.state;
    let tempSearchForm = { ...searchForm };
    delete tempSearchForm["dbID"];
    return (
      <>
        <ApolloProvider client={client.jumperrwdClient}>
          <Query
            query={getResourceJo2DBMapping}
            fetchPolicy="network-only"
            variables={{
              searchForm: tempSearchForm,
            }}>
            {({ loading, error, data, refetch }) => {
              if (loading)
                return (
                  <center>
                    <ReactLoading
                      type="cylon"
                      height={"10%"}
                      width={"20%"}
                      color="#005D98"
                    />
                  </center>
                );
              if (error) return `Error!${error.message}`;
              if (data.getResourceJo2DBMapping) {
                let {
                  jo2DBItemList,
                  maxMoreNum,
                } = data.getResourceJo2DBMapping;
                let dataLength = jo2DBItemList ? jo2DBItemList.length : 0;
                let needShowMore = dataLength > maxMoreNum && maxMoreNum !== 0;
                return (
                  <div className="tab-content">
                    <div className="subtitle">{t("jumper.common.tabbar.byjo2db")}</div>
                    <ul className="items open">
                      {jo2DBItemList &&
                        jo2DBItemList.map((jo2DBItem, k) => {
                          if (showMore || ((!showMore && k < maxMoreNum) || maxMoreNum === 0)) {
                            return (
                              <li>
                                <a
                                  tabIndex="0"
                                  className={
                                    this.props.searchForm.dbID ===
                                    jo2DBItem.resourceID
                                      ? "active"
                                      : ""
                                  }
                                  onClick={this.setDBID.bind(
                                    this,
                                    jo2DBItem.resourceID
                                  )}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      this.setDBID(jo2DBItem.resourceID, e);
                                    }
                                  }}>
                                  {language === "en" &&
                                  jo2DBItem.enEbName !== ""
                                    ? jo2DBItem.enEbName
                                    : jo2DBItem.ebName}
                                  <span>({jo2DBItem.jo2DBCount})</span>
                                </a>
                              </li>
                            );
                          }
                          return "";
                        })}
                    </ul>
                    {needShowMore && !showMore && (
                      <button
                        type="button"
                        tabIndex="0"
                        className="btn_switch"
                        onClick={this.changeShowMore.bind(this, true)}>
                        {t("jumperrwd.common.seeMore")}
                      </button>
                    )}
                    {needShowMore && showMore && (
                      <button
                        type="button"
                        tabIndex="0"
                        className="btn_switch turnicon"
                        onClick={this.changeShowMore.bind(this, false)}>
                        {t("jumperrwd.common.seeLess")}
                      </button>
                    )}
                  </div>
                );
              }
              return "";
            }}
          </Query>
        </ApolloProvider>
      </>
    );
  }
}

export default ResourceJo2DBMapping;
